import { callApi } from '@/helpers/api';
import CONFIG from '@/config/global';

const { api: { PROXY_HOST, GET_RANDOM_STORY } } = CONFIG;

const getRandomStory = () => {
  return callApi({ url: PROXY_HOST(GET_RANDOM_STORY) + GET_RANDOM_STORY });
};

export default getRandomStory;